/**
 * DYT Remix cart handoff — fetches /cart.js token (+ optional discount_code cookie)
 * and opens the hosted cart page with ?cartId= and ?discount= when present.
 *
 * Requires elements with class js-dyt-view-cart and data-remix-cart-url set to the
 * cart page base URL (e.g. https://cart.dressyourtech.co.za/cart).
 */
(function () {
  function readDiscountCode() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : null;
  }

  function buildRemixCartUrl(base, cartToken) {
    var url = base;
    var sep = base.indexOf('?') === -1 ? '?' : '&';
    if (cartToken) {
      url += sep + 'cartId=' + encodeURIComponent(cartToken);
      sep = '&';
    }
    var discount = readDiscountCode();
    if (discount) {
      url += sep + 'discount=' + encodeURIComponent(discount);
    }
    return url;
  }

  function setViewCartLoading(link, loading) {
    if (loading) {
      if (!link.dataset.dytOriginalLabel) {
        link.dataset.dytOriginalLabel = link.textContent || '';
      }
      link.textContent = 'Loading…';
      link.setAttribute('aria-busy', 'true');
      link.classList.add('dyt-view-cart--loading');
      link.style.pointerEvents = 'none';
    } else {
      if (link.dataset.dytOriginalLabel) {
        link.textContent = link.dataset.dytOriginalLabel;
      }
      link.removeAttribute('aria-busy');
      link.classList.remove('dyt-view-cart--loading');
      link.style.pointerEvents = '';
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.js-dyt-view-cart');
    if (!link) return;
    event.preventDefault();
    var base =
      link.dataset.remixCartUrl ||
      (window.dytRemixCart && window.dytRemixCart.cartPageUrl);
    if (!base) return;

    setViewCartLoading(link, true);

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        window.location.href = buildRemixCartUrl(base, cart.token || null);
      })
      .catch(function () {
        window.location.href = buildRemixCartUrl(base, null);
      });
  });
})();
